"use strict";
// Reusable Stevie Images for tiles
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = exports.resetAll = void 0;
var common_sidecar_1 = require("@main/common-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var recyclers = [];
function resetAll() {
    var e_1, _a;
    try {
        for (var recyclers_1 = __values(recyclers), recyclers_1_1 = recyclers_1.next(); !recyclers_1_1.done; recyclers_1_1 = recyclers_1.next()) {
            var r = recyclers_1_1.value;
            r.reset();
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (recyclers_1_1 && !recyclers_1_1.done && (_a = recyclers_1.return)) _a.call(recyclers_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
exports.resetAll = resetAll;
function create(name, getLayer) {
    var e_2, _a;
    var _stevieImages = [];
    var _idx = 0;
    try {
        // Make sure no recycler has this name
        for (var recyclers_2 = __values(recyclers), recyclers_2_1 = recyclers_2.next(); !recyclers_2_1.done; recyclers_2_1 = recyclers_2.next()) {
            var r = recyclers_2_1.value;
            if (r.name === name) {
                throw new Error("Recycler with name " + name + " already exists");
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (recyclers_2_1 && !recyclers_2_1.done && (_a = recyclers_2.return)) _a.call(recyclers_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    var _layer = null;
    function getNext(x, y, frame, liveForSeconds) {
        if (liveForSeconds === void 0) { liveForSeconds = 0; }
        var scale = 0.5; // * 1.01 // Slight overscale to correct for gaps
        // TODO: need to add more gap between tiles in ssp files as well
        while (true) {
            if (_idx >= _stevieImages.length) {
                // Create a new one
                if (!_layer) {
                    _layer = getLayer();
                }
                var image = spritesUtil_sidecar_1.spritesUtil.createImage(_layer, frame);
                spritesUtil_sidecar_1.spritesUtil.scale(image, scale);
                image.visible = true;
                image.x = x;
                image.y = y;
                // image.originY = (frame.w - (frame.ty || 0)) / 2
                image.rotation = 0;
                image.alpha = 1;
                image.tint = 0xffffff;
                _stevieImages.push({
                    img: image,
                    isUsed: true,
                    liveForSeconds: liveForSeconds,
                });
                return image;
            }
            if (!_stevieImages[_idx].isUsed) {
                // Reuse it
                var image = _stevieImages[_idx].img;
                changeImageFrame(image, frame);
                image.x = x;
                image.y = y;
                // image.originY = (frame.w - (frame.ty || 0)) / 2
                // image.flipX = false
                // image.flipY = false
                _stevieImages[_idx].isUsed = true;
                _stevieImages[_idx].liveForSeconds = liveForSeconds;
                return image;
            }
            _idx++;
        }
    }
    function changeImageFrame(image, frame) {
        var scale = 0.5;
        spritesUtil_sidecar_1.spritesUtil.setPackedFrame(image, frame);
        spritesUtil_sidecar_1.spritesUtil.scale(image, scale);
        image.visible = true;
        image.rotation = 0;
        image.alpha = 1;
        image.tint = 0xffffff;
        // image.y += frame.th || 0
    }
    function reset() {
        var e_3, _a;
        var dt = common_sidecar_1.common.getUpdateDelta();
        try {
            for (var _stevieImages_1 = __values(_stevieImages), _stevieImages_1_1 = _stevieImages_1.next(); !_stevieImages_1_1.done; _stevieImages_1_1 = _stevieImages_1.next()) {
                var st = _stevieImages_1_1.value;
                if (st.liveForSeconds > 0) {
                    st.liveForSeconds -= dt;
                    if (st.liveForSeconds <= 0) {
                        st.isUsed = false;
                        st.img.visible = false;
                        st.liveForSeconds = 0;
                    }
                }
                else {
                    st.isUsed = false;
                    st.img.visible = false;
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_stevieImages_1_1 && !_stevieImages_1_1.done && (_a = _stevieImages_1.return)) _a.call(_stevieImages_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        _idx = 0;
    }
    var recycler = {
        name: name,
        getNext: getNext,
        changeImageFrame: changeImageFrame,
        reset: reset,
    };
    recyclers.push(recycler);
    return recycler;
}
exports.create = create;
